export class ClassStatus {
    id: string;
    name: string;
}

export const ClASS_STATUS: ClassStatus[] = [
    {
        id: 'opened',
        name: 'Opened'
    },
    {
        id: 'closed',
        name: 'Closed'
    }
];




// WEBPACK FOOTER //
// ./src/holiday/models/ClassStatus.ts